<template>
  <div>
    <el-dialog :width="Diawidth" :visible.sync="dialogVisible" v-dialogDrag :before-close="handleClose"
      :close-on-click-modal="true" :show-close="true" :close-on-press-escape="true" title="本月巡查统计详情">
      <!-- <div class="Diatitles">淤地坝详情</div> -->
      <el-table :data="tableData" :row-class-name="rowIndex" stripe style="width: 100%;" height="600">
        <el-table-column :formatter="order" label="序号" width="60"></el-table-column>
        <el-table-column prop="ydbNames" label="坝名" width="120"></el-table-column>
        <el-table-column prop="ydbFxxczrr" label="巡查人" width="80"></el-table-column>
        <el-table-column prop="ydbFxxczrrLxfs" label="巡查人联系方式" width="140"></el-table-column>
        <el-table-column prop="ydbXjjhMc" label="巡查名称" width="200"></el-table-column>
        <el-table-column prop="ydbXjrq" label="巡查日期" width="110"></el-table-column>
        <el-table-column prop="ydbYczk" label="巡查情况" width="200"></el-table-column>
        <!-- <el-table-column prop="ydbJcnd" label="建成年月" width="90"></el-table-column>
        <el-table-column prop="ydbSnzc" label="枢纽组成" width="200"></el-table-column>
        <el-table-column prop="ydbSszl" label="所在流域" width="90"></el-table-column>
        <el-table-column prop="ydbKzmj" label="控制面积(k㎡)" width="130"></el-table-column>
        <el-table-column prop="ydbZkr" label="总库容(万m³)" width="120"></el-table-column>
        <el-table-column prop="ydbSjyjkr" label="设计淤积库容(万m³)" width="170"></el-table-column>
        <el-table-column prop="ydbYykr" label="已淤积库容(万m³)" width="160"></el-table-column>
        <el-table-column prop="ydbDhkr" label="滞洪库容(万m³)" width="140"></el-table-column> -->
      </el-table>

      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[15, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum">
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
  import {
    xcInfoForYear,
  } from "@/api/api.js";
  export default {
    props: ["xcClickName", 'ydbCode'],
    data() {
      return {
        dialogVisible: true,
        Diawidth: "50%",
        currentPage: 1,
        pageSize: 15,
        tableData: [],
        totalNum: 0,
      }
    },
    mounted() {
      // console.log(this.ydbCode)
      let params = {
        ydbCode: this.ydbCode,
        startDate: this.xcClickName[0].month,
        // generalField: xcInfoForYear,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      };
      this.xcInfoFun(params);
    },
    methods: {
      xcInfoFun(params) {
        xcInfoForYear(params).then((res) => {
          // console.log(res)
          this.totalNum = res.total;
          this.tableData = res.data;
        });
      },

      handleClose(done) {
        this.dialogVisible = false;
        this.$emit("cancel", {
          "dialogVisible": this.dialogVisible
        })
      },

      cancel() { //取消
        this.dialogVisible = false;
        this.$emit("cancel", {
          "dialogVisible": this.dialogVisible
        })
      },

      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pageSize = val;

        let params = {
          ydbCode: this.ydbCode,
          // generalField: this.xcClickName,
          startDate: this.xcClickName[0].month,
          pageNum: this.currentPage,
          pageSize: this.pageSize
        };
        this.xcInfoFun(params);
      },

      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.currentPage = val;

        let params = {
          ydbCode: this.ydbCode,
          // generalField: this.xcClickName,
          startDate: this.xcClickName[0].month,
          pageNum: this.currentPage,
          pageSize: this.pageSize
        };
        this.xcInfoFun(params);
      },

      rowIndex({
        row,
        rowIndex
      }) {
        row.rowIndex = rowIndex;
      },

      order(row) {
        return this.pageSize * (this.currentPage - 1) + row.rowIndex + 1;
      }
    }
  }
</script>

<style scoped>
  >>>.el-dialog {
    height: 700px;
    background: url(../../common/images/dialog.png) no-repeat center;
    background-size: 100% 100%;
  }

  >>>.el-dialog__body {
    height: 610px;
    padding-top: 0;
  }

  >>>.el-dialog__header {
    /* border: none; */
    padding-left: 0;
    margin: 10px 20px 8px 20px;
  }
  
  >>>.el-dialog__body, .el-dialog__footer{
      background: transparent;
  }

  .Diatitles {
    width: 100%;
    height: 30px;
    border-bottom: 1px solid #214e69;
    /* background-color: #ffe557; */
  }

  .Diatitles li {
    float: left;
    padding: 0px 20px;
    line-height: 30px;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
  }

  .active {
    color: #ffe557 !important;
    border-bottom: 1px solid #ffe557;
  }

  .liucheng {
    width: 456px;
    height: 435px;
    margin-top: 50px;
    margin-left: 40px;
  }

  >>>.el-table {
    margin-top: 10px;
    border-color: #0077AA;
    background-color: transparent !important;
  }

  >>>.el-table thead {
    background-color: rgba(0, 179, 254, 0.5) !important;
  }

  >>>.el-table .cell {
    text-align: center;
    font-size: 16px;
    color: #eaeaea;
  }

  >>>.el-table th {
    background-color: transparent !important;
    border-color: #0077AA;
  }

  >>>.el-table tr {
    background-color: transparent !important;
  }

  >>>.el-table td,
  >>>.el-table th.is-leaf {
    border-color: #0077AA;
  }

  >>>.el-table__body tr:hover>td {
    background-color: rgba(0, 179, 254, 0.3) !important;
  }

  >>>.el-table--border::after,
  >>>.el-table--group::after,
  >>>.el-table::before {
    background-color: #0077AA;
  }

  >>>.el-table--striped .el-table__body tr.el-table__row--striped td {
    background-color: rgba(0, 179, 254, 0.1);
  }

  >>>.el-pagination {
    margin-top: 4px;
    text-align: center;
    color: #fff;
  }

  >>>.el-pagination__total {
    color: #fff;
  }

  >>>.el-pagination__jump {
    color: #fff;
  }

  >>>.el-input__inner {
    background: transparent;
    color: #fff;
  }

  >>>.el-pager li {
    background: transparent;
    border: 0.5px solid #fff;
    padding: 0;
    margin: 0 4px;
  }

  >>>.el-pager li.btn-quicknext,
  .el-pager li.btn-quickprev {
    color: #fff;
  }

  >>>.el-pager .more::before {
    color: #fff;
  }

  >>>.el-pagination .btn-prev {
    background: transparent;
    color: #fff;
  }

  >>>.el-pagination .btn-next {
    background: transparent;
    color: #fff;
  }

  >>>.el-pager li.active+li {
    border-left: 1px solid #fff !important;
  }
</style>
